import type { FaireProductEntity } from "../../entity_types/product";

export const p_b6p8fva3yv: FaireProductEntity = {
  token: "p_b6p8fva3yv",
  type: "product",
  name: "Groom Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/fb920290ed08629b971d41c5ea4bb489654f942ebcf722db27f84c1a22de52b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a20b6601d35190f74eadc9dd50cc62ae4bb969e6df8ca158d70ccf6320c90680.jpeg",
    "https://cdn.faire.com/fastly/d991805c0ff7510a3b2f7edd0d584b9599800f8d4235b858a612c01f03bece7a.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/aed99152c98decb2fc3d7e5d4f2a6eac6025e21474957d7b4eb4db04a737bad9.jpeg",
    "https://cdn.faire.com/fastly/bd4bac366a393169d4aa62e589789a27299d19ca0d8b3455e0d84540d6dd6cad.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are for the man who spent a year answering wedding questions, making some serious compromises on the dance playlist, and saving his best answer for one perfect day: “I do.” A fun groom gift for getting ready, the wedding weekend, or a bachelor party celebration.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:30.416Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
